class @App.Components.Subnavbar
  constructor: ->
    selected = location.hash.replace(/-section.*?$/i, '')
    @$startPage = $('[data-page="' + selected + '"]:first')
    @$element = $('[data-component="subnavbar"]')
    @$pageLinks = $('[data-action="pageChange"]')
    @$pages = @.getItems('[data-page]', 'page')
    @$masts = @.getItems('[data-mast]', 'mast')

    $(document).on 'ready', (e) =>
      if (@$startPage.length > 0)
        @.changePage(@$startPage)

      $(window).on 'hashchange', (e) =>
        selected = location.hash.replace(/-section.*?$/i, '')
        $pageLink = $('[data-page="' + selected + '"]:first')
        if ($pageLink.length > 0)
          @.changePage($pageLink)
        false

      @$element.on 'click', '[data-action="pageChange"]', (e) =>
        e.preventDefault()
        $pageLink = $(e.target)
        @.changePage($pageLink)
        false

      if @$element.data('renew')
        $('a[data-page="#renew"]').click()
        others = $('[data-action="pageChange"]').not('a[data-page="#renew"]')
        others.css('color', '#717171')
        others.css('pointer-events', 'none')

      return

  getItems: (selector, dataKey) =>
    $items = []

    @$element.find(selector).each((i) ->
      id = $(@).data(dataKey)
      $items.push $(id)
      return
    )

    return $items

  changePage: ($pageLink) =>
    pageId = $pageLink.data('page')
    mastId = $pageLink.data('mast')

    if $pageLink.hasClass 'is-active'
      return

    @$pageLinks.removeClass('is-active')
    $pageLink.addClass('is-active')

    $(page).hide() for page in @$pages
    $(window).trigger 'teded_subnav_page_changing', pageId
    $(pageId).fadeIn () ->
      $(window).trigger 'teded_subnav_page_changed', pageId

    history.pushState('', '', pageId + '-section')

    if (mastId)
      $(mast).hide() for mast in @$masts
      $(mastId).fadeIn()

    $.scrollTo(0, 250)
    return

$(document).on 'turbo:load', ->
  new App.Components.Subnavbar
